import { useCallback, useEffect, useMemo, useState } from "react";
import { getMesEquipes } from "../services/mesEquipesService";
import { adaptTeamResponse, EMPTY_STATS } from "../utils/mesEquipes";

export default function useMesEquipes() {
  const [filters, setFilters] = useState({ mot_cle: "", direction: null, service: null });
  const [keyword, setKeyword] = useState("");
  const [pagination, setPagination] = useState({ page: 0, pageSize: 10 });
  const [refresh, setRefresh] = useState(0);
  const [snapshot, setSnapshot] = useState({ rows: [], total: 0, stats: EMPTY_STATS, directions: [],
    filters: { directions: [], services: [] } });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setKeyword(filters.mot_cle), 350);
    return () => clearTimeout(timer);
  }, [filters.mot_cle]);

  const params = useMemo(() => ({
    mot_cle: keyword, direction_id: filters.direction?.direction_id,
    service_id: filters.service?.service_id, page: pagination.page + 1, page_size: pagination.pageSize,
  }), [keyword, filters.direction, filters.service, pagination]);

  useEffect(() => {
    if (filters.mot_cle !== keyword) return undefined;
    const controller = new AbortController();
    setLoading(true);
    setError("");
    getMesEquipes(params, controller.signal).then((response) => {
      if (controller.signal.aborted) return;
      if (params.page > 1 && response.data.length === 0) {
        setPagination((current) => ({ ...current, page: 0 }));
        return;
      }
      setSnapshot(adaptTeamResponse(response));
    }).catch((failure) => {
      if (!controller.signal.aborted) setError(failure.response?.data?.message || failure.message);
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [params, refresh, keyword, filters.mot_cle]);

  const changeFilters = useCallback((patch) => {
    setFilters((current) => ({ ...current, ...patch }));
    setPagination((current) => ({ ...current, page: 0 }));
  }, []);
  const resetFilters = () => changeFilters({ mot_cle: "", direction: null, service: null });
  const refreshList = () => setRefresh((current) => current + 1);
  return { ...snapshot, filters, filterOptions: snapshot.filters, loading: loading || filters.mot_cle !== keyword, error, params,
    pagination, setPagination, changeFilters, resetFilters, refreshList };
}
